import { faArrowUpShortWide, faObjectGroup } from '@fortawesome/free-solid-svg-icons';
import {
  faBoxOpen,
  faClipboard,
  faExclamationCircle,
  faPercent,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import ConvertedUnits from 'src/components/ConvertedUnits';
import TruncatedTitle from 'src/components/TruncatedTitle';
import { getShortUuid } from 'src/utils/url';

const MaterialLotCardDetails = ({ lot, materials, state, debugMode, customMainStyle, dataCy }) => {
  if (!lot) return null;

  if (state.error) {
    return (
      <p className='error-loading-card-resource'>
        <FontAwesomeIcon icon={faExclamationCircle} className='d-block spacer-right danger-color' />
        An error occurred while loading the Lots Data.
      </p>
    );
  }

  // eslint-disable-next-line camelcase
  const lotMaterial = materials.find(({ material_lot_uri }) => material_lot_uri === lot.uri);

  return (
    <div className='material-lot-card-details' style={customMainStyle} data-cy={dataCy}>
      <div className='material-lot-card-details-header'>
        <FontAwesomeIcon icon={faBoxOpen} className='spacer-right' />
        <div className='d-flex flex-column align-items-center'>
          <TruncatedTitle
            inline
            title={lot.name}
            titleClassName='mb0'
            maxTextLength={25}
            maxTextLengthMobile={20}
            dataCy={dataCy && `${dataCy}-name`}
          />
          {debugMode && <span className='spacer-left'>({getShortUuid(lot.uri)})</span>}
        </div>
      </div>
      <div className='material-lot-card-details-body'>
        <div className='text-left'>
          <p data-cy={dataCy && `${dataCy}-delivery-id`}>
            <FontAwesomeIcon className='spacer-right' icon={faClipboard} />
            {lot.delivery_id || 'N/A'}
          </p>
          <p className='mb0' data-cy={dataCy && `${dataCy}-percentage`}>
            <FontAwesomeIcon className='spacer-right' icon={faPercent} />
            {lotMaterial?.percentage || 'N/A'}
          </p>
        </div>
        <div className='material-lot-card-details-body-right-details'>
          <p>
            <ConvertedUnits
              quantity={lot.quantity}
              units={lot.units}
              dataCy={dataCy && `${dataCy}-quantity`}
            />
            <FontAwesomeIcon className='spacer-left' icon={faArrowUpShortWide} />
          </p>
          <p className='mb0'>
            <TruncatedTitle
              inline
              title={lot.material_name}
              titleClassName='mb0'
              maxTextLength={25}
              maxTextLengthMobile={20}
              dataCy={dataCy && `${dataCy}-material-name`}
            />
            <FontAwesomeIcon className='spacer-left' icon={faObjectGroup} />
          </p>
        </div>
      </div>
    </div>
  );
};

MaterialLotCardDetails.defaultProps = {
  customMainStyle: {},
  dataCy: null,
};

MaterialLotCardDetails.propTypes = {
  /* eslint-disable camelcase */
  lot: PropTypes.shape({
    name: PropTypes.string,
    uri: PropTypes.string,
    units: PropTypes.string,
    status: PropTypes.string,
    quantity: PropTypes.number,
    delivery_id: PropTypes.string,
    usage_cycles: PropTypes.number,
    material_name: PropTypes.string,
  }),
  state: PropTypes.shape({
    error: PropTypes.bool,
  }).isRequired,
  debugMode: PropTypes.bool.isRequired,
  materials: PropTypes.arrayOf(
    PropTypes.shape({
      percentage: PropTypes.number,
    })
  ).isRequired,
  customMainStyle: PropTypes.shape({}),
  dataCy: PropTypes.string,
};

export default MaterialLotCardDetails;
